import {Button, useTheme} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledButton = styled(Button)(({theme, variant}) => ({
    ...(variant === "text" && {
        color: theme.palette.primary.main,
        fontSize: 18,
    }),
    ...(variant === "contained" && {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        fontSize: "16px"
    }),
    
    ...(variant === "outlined" && {
        height: 45,
        backgroundColor: "transparent",
        fontSize: "16px",
        color: theme.typography.primary,
        borderColor: "#e5edf6",
        "&:hover": {
            // ",
        }
    }),
    
    textTransform: "none", 
    padding: '8px 16px',
    fontWeight: "400", 
}));

const CustomButton = ({variant, startIcon, label, onClick, customStyles, disabled, disableRipple, endIcon, ...props }) => {
    const theme = useTheme();

    return (
        <StyledButton 
            disableRipple={disableRipple}
            variant={variant} 
            startIcon={startIcon}
            endIcon={endIcon || null} 
            label={label}
            onClick={onClick} 
            disabled={disabled}
            sx={{
                ...customStyles 
            }} 
            {...props}
        >
            {label}
        </StyledButton>
    );
}

export default CustomButton
